import { type QueryHookOptions, useQuery } from "@apollo/client";
import { LinkQuery } from "../graphql/queries";
import type { LinkQueryType } from "@/types/graphql/partner.generated";

export const useLinkQuery = (options?: QueryHookOptions<LinkQueryType>) => {
  return useQuery<LinkQueryType>(LinkQuery, options);
};
